import { createTypes, async } from 'redux-action-creator';
import asyncAction from '../../../asyncActionCreator';
import { types as workItemsTypes } from './waiverWorkItemsActions';

import {
  getWaiverWorkItemDetails,
  upsertWaiverWorkItem as serviceUpdateWaiverWorkItem,
} from '../../../../service/waiverWorkItemService';
import { snoozeWaiverConfiguration } from '../../../../service/waiverConfigurationService';
import type {
  ThunkAction,
  Dispatch,
  PromiseResultActions,
} from '../../../types';
import type {
  WaiverWorkItem,
  WaiverWorkItemDetailsResponse,
  WaiverWorkItemAction,
} from '../../../../types/waiverWorkItem';

export const types: { [key: string]: string } = createTypes(
  [
    ...async('LOAD_DETAILS'),
    ...async('UPDATE'),
    ...async('CHANGE_WAIVER_ASSOCIATON'),
    ...async('SNOOZE_NOTIFICATIONS'),
  ],
  'WAIVER_WORK_ITEM',
);

export const fetchWaiverWorkItemDetails = (workItemId: number): ThunkAction => {
  return (dispatch: Dispatch) => {
    dispatch({ type: types.LOAD_DETAILS });
    dispatch({ type: workItemsTypes.SYNC });
    return getWaiverWorkItemDetails(workItemId).then(
      (detailsResponse: WaiverWorkItemDetailsResponse) => {
        dispatch({
          type: types.LOAD_DETAILS_SUCCESS,
          response: detailsResponse.workItemDetails,
        });
        dispatch({
          type: workItemsTypes.SYNC_SUCCESS,
          response: [detailsResponse.workItem],
        });
      },
      error => {
        dispatch({ type: types.LOAD_DETAILS_FAIL, error: error });
        dispatch({ type: workItemsTypes.SYNC_FAIL, error: error });
      },
    );
  };
};

export const updateWaiverWorkItem = (workItem: WaiverWorkItem): ThunkAction => {
  return asyncAction(
    types.UPDATE,
    () => serviceUpdateWaiverWorkItem(workItem),
    {
      before: (dispatch: Dispatch) => dispatch({ type: workItemsTypes.SYNC }),
      then: (dispatch: Dispatch, updatedWorkItem: WaiverWorkItem) =>
        dispatch({
          type: workItemsTypes.SYNC_SUCCESS,
          response: [updatedWorkItem],
        }),
      error: (dispatch: Dispatch, error: Error) =>
        dispatch({ type: workItemsTypes.SYNC_FAIL, error: error }),
    },
  );
};

export function snoozeNotificationsForAirline(
  airlineCode: string,
  hoursToSnooze: number,
  promiseActions?: PromiseResultActions<any, string>,
): (dispatch: Dispatch) => Promise<any> {
  return asyncAction(
    types.SNOOZE_NOTIFICATIONS,
    () => snoozeWaiverConfiguration(airlineCode, hoursToSnooze),
    promiseActions,
  );
}

export const executeWaiverWorkItemAction = (
  action: WaiverWorkItemAction,
  workItem: WaiverWorkItem,
): ThunkAction => {
  return (dispatch: Dispatch) => action.action(dispatch, workItem);
};
